import { t as localeText } from "@/shared/lib/translate";
import { useTranslation as useLocaleSubscription } from "react-i18next";
import { useEffect, useRef } from "react";
import { Spinner } from "./Spinner";

/** Observe the end of the current result set, including pages with no filter matches. */
export function InfiniteScrollSentinel({ count, hasMore, loading, error = false, onLoadMore }: {
  count: number;
  hasMore: boolean;
  loading: boolean;
  error?: boolean;
  onLoadMore: () => void;
}) {
  useLocaleSubscription();
  const sentinel = useRef<HTMLDivElement>(null);
  const callback = useRef(onLoadMore);
  useEffect(() => { callback.current = onLoadMore; }, [onLoadMore]);
  useEffect(() => {
    const node = sentinel.current;
    if (!node || !hasMore || loading || error || typeof IntersectionObserver === "undefined") return;
    let requested = false;
    const observer = new IntersectionObserver(entries => {
      if (!requested && entries.some(entry => entry.isIntersecting)) {
        requested = true;
        callback.current();
      }
    }, { root: node.closest("[data-results-scroll]"), rootMargin: "320px" });
    observer.observe(node);
    return () => observer.disconnect();
  }, [count, hasMore, loading, error]);
  return <div ref={sentinel} className="flex min-h-1 justify-center" data-load-sentinel="">
    {loading ? <Spinner label={localeText("interface.loading_more_images_22c849bd", { defaultValue: "Loading more images…" })} className="my-4" /> : null}
  </div>;
}
